import { Component, OnInit, Input } from '@angular/core';
import { Column } from 'src/app/reports/components/report/models/column.model';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  animations:[
    trigger('handler-visibility', [
      state('hidden', style({
        'margin-right': '-20px',
        opacity: 0
      })),
      state('visible', style({
        opacity: 1
      })),
      transition('* <=> *', animate('200ms 0s ease'))
    ])
  ],
  selector: 'app-entity-detail',
  templateUrl: './entity-detail.component.html',
  styleUrls: ['./entity-detail.component.scss']
})
export class EntityDetailComponent implements OnInit {

  //#region Inputs

  @Input() disabled : boolean = false;
  @Input() columnHeaders : Array<Column> = new Array<Column>(); 
  @Input() enableScroll : boolean = false;  
  @Input() showDragHandler : boolean = false;

  @Input() columnDragulaGroup : string;
  @Input() linkGroupName: string;

  //#endregion

  //#region Properties

  componentLoaded : boolean = false;

  //#endregion

  //#region Ctor

  constructor() { }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
  }

  //#endregion
}
